import { TermsAndConditionsViewer } from "../steps/TermsAndConditions/components/TermsAndConditionsViewer";

import { type StepProps } from "./taskRenderers";
import { useCompleteTaskV2 } from "./useCompleteTaskV2";

export const DocumentAcceptanceStep = ({ task, onComplete }: StepProps) => {
  const { completeTask, isPending } = useCompleteTaskV2();

  const documents = task.documents.map((document) => ({
    id: document.id,
    label: document.displayName,
    signedUrl: document.signedUrl,
  }));

  const handleAccept = () => {
    completeTask(
      {
        taskId: task.id,
        data: {
          capturedData: {
            acceptedDocumentIds: task.documents.map((document) => document.id),
          },
        },
      },
      { onSuccess: () => onComplete() },
    );
  };

  return (
    <TermsAndConditionsViewer
      documents={documents}
      isAccepting={isPending}
      onAccept={handleAccept}
    />
  );
};
